import React, { createContext, useContext, useState } from "react"

const CountContext = createContext(null);

export const useCountContext = () => {
    const context = useContext(CountContext)
    return context
}

export const CountProvider = ({ children }) => {
    const [count, setCountContext] = useState(0)
    return (
        <CountContext.Provider value={{ count, setCountContext }}>
            {children}
        </CountContext.Provider>
    )
}